/** @format */
import Master from '../Layouts/Master';
import ErrorMessage from '../../Shared/Components/ErrorMessage';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import useApi from '../../Shared/hooks/api/Index';
import { error, success } from '../../Shared/Components/Toast';

const validationSchema = Yup.object().shape({
  title: Yup.string()
    .required('عنوان الزامی است')
    .max(190, 'عنوان نمیتواند بیشتر از 190 کاراکتر باشد'),
  status: Yup.number()
    .typeError('وضعیت الزامی است')
    .required('وضعیت الزامی است')
    .min(0, 'وضعیت باید 0 و یا 1 باشد')
    .max(1, 'وضعیت باید 0 و یا 1 باشد'),
});

const Create = () => {
  const navigate = useNavigate();
  const [submitFormLoading, setSubmitFormLoading] = useState(false);

  const onSubmitForm = async (values, setSubmitting) => {
    setSubmitFormLoading(true);

    await useApi.post(
      '/fandom',
      values,
      (res) => {
        success('تیم  با موفقیت ایجاد شد');
        navigate('/panel/fandom', { replace: true });
      },
      (err) => {
        setSubmitFormLoading(false);
        error('خطایی در ثبت اطلاعات پیش آمده است.');
      },
    );
  };

  return (
    <Master>
      <Formik
        initialValues={{
          title: '',
          status: 1,
        }}
        onSubmit={(values, { setSubmitting }) => {
          onSubmitForm(values, setSubmitting);
        }}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className='row border rounded mt-3 py-2'>
              <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                <div className='form-group'>
                  <div className='d-flex flex-column mt-1 mx-2'>
                    <label>عنوان تیم</label>
                    <input
                      name='title'
                      value={values.title}
                      onChange={handleChange}
                      type='text'
                      className='form-control'
                    />
                    <ErrorMessage error={errors.title} />
                  </div>
                </div>
              </div>
              <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                <div className='form-group'>
                  <div className='d-flex flex-column'>
                    <label className='f-14 mx-2'>وضعیت</label>
                    <select
                      value={values.status}
                      name='status'
                      onChange={handleChange}
                      className='form-control'
                    >
                      <option value='1'>فعال</option>
                      <option value='0'>غیرفعال</option>
                    </select>
                    <ErrorMessage error={errors.status} />
                  </div>
                </div>
              </div>
              <div className='col-12'>
                <div className='d-flex flex-row justify-content-end'>
                  <button className='btn btn-info btn-sm f-14'>
                    {submitFormLoading ? (
                      <div
                        className='spinner-border spinner-border-sm text-white mb-1'
                        role='status'
                      ></div>
                    ) : (
                      'ثبت تیم'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </Master>
  );
};

export default Create;
